<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ShuMaYinYing1`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.31555 3.86816C3.21098 3.86816 2.31555 4.76359 2.31555 5.86816V19.3682C2.31555 20.4727 3.21098 21.3682 4.31555 21.3682H21.4872C22.5918 21.3682 23.4872 20.4727 23.4872 19.3682V5.86816C23.4872 4.76359 22.5918 3.86816 21.4872 3.86816H4.31555ZM4.54675 5.59375C4.27061 5.59375 4.04675 5.81761 4.04675 6.09375V19.1338C4.04675 19.4099 4.27061 19.6338 4.54675 19.6338H21.256C21.5321 19.6338 21.756 19.4099 21.756 19.1338V6.09375C21.756 5.81761 21.5321 5.59375 21.256 5.59375H4.54675Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.968 17.9307C17.902 17.9307 20.2805 15.5522 20.2805 12.6182 20.2805 9.68415 17.902 7.30566 14.968 7.30566 12.034 7.30566 9.65552 9.68415 9.65552 12.6182 9.65552 15.5522 12.034 17.9307 14.968 17.9307zM14.968 16.0752C16.8797 16.0752 18.4294 14.5255 18.4294 12.6138 18.4294 10.7021 16.8797 9.15234 14.968 9.15234 13.0563 9.15234 11.5066 10.7021 11.5066 12.6138 11.5066 14.5255 13.0563 16.0752 14.968 16.0752zM8.08142 5.59375H6.46619V7.86816H4.04675V9.4834H6.46619V11.8105H4.04675V13.4258H6.46619V15.7529H4.04675V17.3682H6.46619V20.4316H8.08142V5.59375z"/><circle cx="14.968" cy="12.618" r="1.615"/></svg>
</template>
<script>

export default {
  name: 'IconShuMaYinYing1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
